import Assessment from 'actions/assessment';

export default Assessment.createReducer();
